<script>
    const cardsCoreValues = [
        {
            icon: 'images/core_values_section/core_values_img1.svg',
            bodyText:
                'Our entrepreneurs come from over 101 countries and a variety of diverse backgrounds.'+
                ' Our alumni represent various countries including Chile, Estonia, Nepal, '+
                'South Africa, South Korea, Malawi, Senegal and Iraq.',
            title: 'Diversity & Freedom',
        },
        {
            icon: 'images/core_values_section/core_values_img2.svg',
            bodyText:
                'We select on the basis of entrepreneurial spirit, passion, creativity,'+
                ' desire to change the world, and grit. We are investing in YOU so feel free to apply '+
                'before you have a team or startup idea.',
            title: 'Gusto & Enthusiasm',
        },
        {
            icon: 'images/core_values_section/core_values_img3.svg',
            bodyText:
                'You will live with your cohort and build lifelong partnerships.Once you join the Draper family,'+
                ' you are part of a close-knit community for life.',
            title: 'Relationships & Community',
        },
        {
            icon: 'images/core_values_section/core_values_img4.svg',
            bodyText:
                'We even the playing field for our community by bringing in experts, investors and corporate '+
                'leaders so they have access to the best talent, capital and opportunities.',
            title: '<p>Fairness & Opportunity<p>',
        },
    ];
    const cardsCoreValues2 = [
        {
            icon: 'images/core_values_section/core_values_img1.svg',
            bodyText:
                'Our entrepreneurs come from over 101 countries and a variety of diverse backgrounds. '+
                'Our alumni represent various countries including Chile, Estonia, Nepal, South Africa, '+
                'South Korea, Malawi, Senegal and Iraq.',
            title: 'Diversity & Freedom',
        },
        {
            icon: 'images/core_values_section/core_values_img2.svg',
            bodyText:
                'We select on the basis of entrepreneurial spirit, passion, creativity, desire to change the '+
                'world, and grit. We are investing in YOU so feel free to apply before you have a team or startup idea.',
            title: 'Gusto & Enthusiasm',
        },
        {
            icon: 'images/core_values_section/core_values_img3.svg',
            bodyText:
            'You will live with your cohort and build lifelong partnerships.Once you join the Draper family,'+
            ' you are part of a close-knit community for life.',
            title: 'Relationships & Community',
        },
        {
            icon: 'images/core_values_section/core_values_img4.svg',
            bodyText:

                'We even the playing field for our community by bringing in experts, investors and corporate leaders'+
                ' so they have access to the best talent, capital and opportunities.',
            title: '<p>Fairness & Opportunity<p>',
        },
    ];
</script>

<div class="desktop">
    <div class="backgroung-image">
        <img
            src="/images/core_values_section/core-values-background.png"
            alt=""
        />
    </div>

    <div style=" position:relative;">
        <div class="core-values">
            <div class="top-text" />
            <p class="main-heading">Core Values</p>

            <div class="cards">
                {#each cardsCoreValues as card}
                    <div class="card-layout">
                        <div class="card-icon">
                            <img src={card.icon} alt="" />
                        </div>
                        <div class="title"><p>{@html card.title}</p></div>
                        <div class="text"><p>{@html card.bodyText}</p></div>
                    </div>
                {/each}
            </div>
        </div>
    </div>
    <div>
        <div class="bottom-text">
            <p class="bottom-main-heading">The Startup Hero's Pledge</p>
            <p class="text">
                We practice each line of this oath and promote the values we
                aspire to see in the world and our heroes
            </p>
        </div>
        <div class="pledge-button" >
            <button class="btn-css" on:click={() => (location.href = '/pledge')}> Learn about our pledge </button>
            <!-- <a class="button" style="text-decoration: none;" href="/pledge"
                >Learn about our pledge</a
            > -->
        </div>
    </div>
    <div>
        <hr class="footer-line" />
    </div>
</div>
<div class="mobile-version">
    <div class="background" style="width:100%;">
        <h4>The Startup Hero’s Pledge</h4>
        <p>
            We practice each line of this oath and promote the values we aspire
            to see in the world and our heroes
        </p>
        <button class="button-mob">Learn More</button>
    </div>

    <div class="core-value-section">
        <p class="heading">Core Values</p>

        <div class="img">
            {#each cardsCoreValues2 as card}
                <div class="img">
                    <img src={card.icon} alt="" class="img" />
                </div>
                <div class="caption">
                    <p class="caption">{@html card.title}</p>
                </div>
                <div class="para">
                    <p class="para">{@html card.bodyText}</p>
                </div>
            {/each}
        </div>
    </div>
</div>

<style>
    .btn-css {
        height: 3.785vw;
        width: 17.198vw;
        background: #f7e05f;
        color: rgba(60, 116, 192, 1);
        font-size: 0.938vw;
        font-weight: 500;
        border: none;
        padding: 1vw 1.5vw;
        border-radius: 2vw;
    }
    .btn-css:hover {
        background-color: white;
        border: 0.194vw solid rgba(0, 0, 0, 1);
        color: rgba(0, 32, 75, 1);
        height: 3.785vw;
        width: 17.198vw;
        font-size: 0.938vw;
        font-weight: 500;
        padding: 1vw 1.5vw;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .heading {
            width: 33.645vw;
            font-family: "Inter";
            font-style: normal;
            font-weight: 800;
            font-size: 5.607vw;
            line-height: 6.776vw;
            color: #00204b;
            margin: 8vw 29vw;
        }
        .img {
            margin: 5vw 4vw;
        }
        .caption {
            margin: 5vw 4vw;
            color: black;
            width: 62vw;
            font-family: "Inter";
            font-style: normal;
            font-weight: 700;
            font-size: 4.673vw;
            line-height: 5.607vw;
            text-align: left;
            margin-top: -4vw;
        }
        
        .para {
            margin: 0vw 4vw;
            color: black;
            width: 68.925vw;
            font-family: "Inter";
            font-style: normal;
            font-weight: 400;
            font-size: 3.271vw;
            line-height: 3.972vw;
            margin-bottom: 8vw;
            margin-top: -2vw;
        }
        .mobile-version {
            display: block !important;
        }
        .background {
            background-image: url(/images/core_values_section/core-values-mobile-view.png);
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;

            border-radius: 0vw 0vw 7.009vw 7.009vw;
            width: 100vw;
            height: 51.168vw;
        }
        .button-mob {
            height: 6.776vw;
            width: 33.103vw;
            border: none;
            border-radius: 7.009vw;
            background: #f7e05f;
            margin-left: 34vw;
            font-family: "Inter";
            font-style: normal;
            font-weight: 400;
            font-size: 2.804vw;
            line-height: 3.505vw;
            text-align: center;
        }
        p {
            width: 90.654vw;
            font-family: "Inter";
            font-style: italic;
            font-weight: 400;
            font-size: 3.271vw;
            line-height: 3.972vw;
            color: #ffffff;
            margin-top: 5.5vw;
            margin-left: 6vw;
        }
        h4 {
            width: 59.579vw;
            font-family: "Inter";
            font-style: normal;
            font-weight: 700;
            font-size: 4.673vw;
            line-height: 5.607vw;
            color: #ffffff;
            padding-top: 10vw;
            margin-left: 6vw;
        }
    }

    .backgroung-image img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 5.952vw;
        border-radius: 1.984vw;
        width: 96.813vw;
        height: 38vw;
    }
    .mobile-version {
        display: none;
    }
    .core-values {
        background: rgba(248, 252, 255, 1);
        position: absolute;
        width: 86.190vw;
        left: 6.906vw;
        border-radius: 1.984vw;
        top: -16.584vw;
        box-shadow: 0px -1.004px 30.1199px rgba(0, 0, 0, 0.25);
    }

    .card-icon img {
        display: flex;
        width: 3.5vw;
        height: 3.2vw;
        margin-left: 0.1vw;
    }
    .card-layout {
        width: 15.013vw;
        margin-bottom: 3vw;
        justify-content: space-between;
    }

    .cards {
        display: flex;
        justify-content: space-between;
        margin-top: 4.860vw;
        padding: 0vw 5.644vw;
    }
    .card-layout .text {
        margin-top: 2.523vw;
    }

    .pledge-button {
        margin-top: -5.455vw;
        margin-left: 67.663vw;
       
    }

    /* .button {
        height: 3.785vw;
        width: 17.198vw;
        background: #f7e05f;
        color: rgba(60, 116, 192, 1);
        font-size: 1.062vw;
        font-weight: 500;
        border: none;
        padding: 1vw 1.5vw;
        border-radius: 2vw;
    } */
    .top-text {
        padding-top: 1.993vw;
        margin-bottom: 4.86vw;
    }

    .bottom-main-heading {
        margin-top: 25.17vw;
        font-size: 1.587vw;
        font-weight: 700;
        line-height: 1.929vw;
        margin-left: 15.803vw;
    }

    .main-heading {
        color: #002659;
        font-size: 2.646vw;
        font-weight: 800;
        margin-top: -4.519vw;
        text-align: center;
    }
    .text {
        color: #00204bcc;
        font-weight: 400;
        font-size: 0.926vw;
        width: 15.013vw;
        margin-left: 0vw;
    }

    .title {
        font-weight: 700;
        font-size: 1.587vw;
        line-height: 1.926vw;
        color: #00204b;
        width: 14.085vw;
        justify-content: center;
        margin-top: 1vw;
    }
    .bottom-text .text {
        font-weight: 400;
        margin-left: 16.135vw;
        margin-top: 1.66vw;
        font-style: italic;
        width: 45.153vw;
        font-size: 0.926vw;
        color: rgba(0, 32, 75, 1);
    }
    .footer-line {
        margin-top: 4.382vw;
        margin-left: 10.159vw;
    }
    hr {
        width: 79.681vw;
        opacity: 1;
        color: #e5e5e5;
        height:0.199vw;
    }
</style>
